import { EncodeUrl } from '@pkg/classes';

import { apiFactory, type ApiResult } from '@app/client';
import { callProxy, ProxyService } from '@app/client/resources/proxy';

export interface RedirectUrlItems {
    url: string;
    displayUrl: string;
    protocol: string;
}

interface Params {
    url: string;
    isMobileWidth?: boolean;
}

interface PageMetaItem {
    content: string;
    property: string;
    name?: string;
}

export interface PageMetas {
    meta: PageMetaItem[];
}

export function getDisplayUrl(url = ''): RedirectUrlItems {
    const previewImageUrl = { url: '', displayUrl: '', protocol: 'https' };
    const urlTrimmed = url.trim();

    if (urlTrimmed.indexOf('https://') === 0) {
        previewImageUrl.url = urlTrimmed;
        previewImageUrl.displayUrl = urlTrimmed.replace('https://', '');
        previewImageUrl.protocol = 'https';
    } else if (urlTrimmed.indexOf('http://') === 0) {
        previewImageUrl.url = urlTrimmed;
        previewImageUrl.displayUrl = url.replace('http://', '');
        previewImageUrl.protocol = 'http';
    } else {
        previewImageUrl.url = `https://${urlTrimmed}`;
        previewImageUrl.displayUrl = urlTrimmed;
    }

    previewImageUrl.displayUrl = EncodeUrl.isEncoded(previewImageUrl.displayUrl)
        ? decodeURI(previewImageUrl.displayUrl)
        : previewImageUrl.displayUrl;

    return previewImageUrl;
}

export async function callMetaProxy({ url }: Params): Promise<ApiResult<PageMetas>> {
    try {
        const result = await apiFactory().call(callProxy, {
            value: { service: ProxyService.Scraper, data: url },
        });

        if (result && result.ok) {
            const parsedData = JSON.parse(result.value.value);
            return {
                ok: true,
                value: parsedData,
                headers: result.headers,
                status: result.status,
            };
        } else {
            return result;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
        return {
            ok: false,
            status: {
                code: 0,
                text: 'Error',
            },
            error,
            headers: new Headers(),
        };
    }
}
